import { create } from 'zustand'

//zustend 스테이트 설정
//입고등록수정조회
export const useStoresIpgo = create((set) => ({
    ipgoprintopentrue: false,
    ipgoprintopenhangmok: {},
    ipgoprintopenquality: {},
    //ipgoprintopentrue:() => set((state) => ({ ipgoprintopen: state.ipgoprintopen})),

  })
);
//기상청 쥬스텐드 변수설정
export const useStoresWatch = create((set) => ({
  watchTimersub: '0500',  //기상청 시간체크하기
}))


//쥬스텐드 zst 익셔텐셔 확인할것





